if (!customElements.get('oq-mobile-purchase')) {
  customElements.define('oq-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      const section = this.dataset.section;
      this.main = document.getElementById('MainProduct-' + section);
      this.original = document.getElementById('ProductSubmitButton-' + section);
      this.button = this.querySelector('button');
      if (!this.original || !this.main) { this.hidden=true; return; }
      const data = JSON.parse(this.querySelector('script').textContent);
      this.refresh = () => {
        const input = document.getElementById('product-form-' + section)?.querySelector('[name="id"]');
        const variant = data.variants.find(v => String(v.id) === input?.value);
        const summary = this.querySelector('.oq-mobile-configuration');
        if (summary) summary.textContent = variant?.title && variant.title !== 'Default Title' ? variant.title.replaceAll(' / ', ' · ') : '';
        this.button.disabled = this.original.disabled || this.original.getAttribute('aria-disabled') === 'true' || !variant?.available;
        this.button.textContent = this.original.querySelector('span')?.textContent.trim() || this.original.textContent.trim();
        this.querySelector('.oq-mobile-price').textContent = variant ? new Intl.NumberFormat(document.documentElement.lang, {style:'currency',currency:data.currency}).format(variant.price/100) : '';
      };
      this.activate = () => { if (!this.button.disabled) this.original.click(); };
      this.button.addEventListener('click',this.activate);
      this.main.addEventListener('change',this.refresh);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.original,{attributes:true,childList:true,subtree:true,characterData:true});
      if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {if(event.data.sectionId===section) this.refresh();});
      this.refresh();
    }
    disconnectedCallback() {this.observer?.disconnect();this.unsubscribe?.();this.main?.removeEventListener('change',this.refresh);this.button?.removeEventListener('click',this.activate);}
  });
}
